"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createJourney = void 0;
var _utils = require("../utils");
var _journeyLite = _interopRequireDefault(require("./journey-lite"));
var _orderJourneyProducts = _interopRequireDefault(require("./order-journey-products"));
var _seo = _interopRequireDefault(require("./seo"));
var _journeySection = _interopRequireDefault(require("./journey-section"));
var _journeyStep = _interopRequireDefault(require("./journey-step"));
var _journeyService = _interopRequireDefault(require("./journey-service"));
var _conditionalDestination = _interopRequireDefault(require("./conditional-destination"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createJourney = function createJourney(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var contentType = (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id');
  var journeySections = (0, _utils.getProp)(fields, 'sections') || [];
  var productLine = (0, _utils.getProp)(fields, 'productLine');
  var extras = (0, _utils.getProp)(fields, 'extras') || [];
  var sections = [];
  var steps = [];
  journeySections.filter(function (section) {
    var _section$fields, _section$fields$site;
    return section === null || section === void 0 ? void 0 : (_section$fields = section.fields) === null || _section$fields === void 0 ? void 0 : (_section$fields$site = _section$fields.site) === null || _section$fields$site === void 0 ? void 0 : _section$fields$site.includes(process.env.NEXT_PUBLIC_SITE);
  }).forEach(function (section) {
    var sectionSteps = (0, _utils.getProp)(section.fields, 'steps') || [];
    sections.push((0, _journeySection["default"])(section));
    sectionSteps.filter(function (step) {
      var _step$fields, _step$fields$site;
      return step === null || step === void 0 ? void 0 : (_step$fields = step.fields) === null || _step$fields === void 0 ? void 0 : (_step$fields$site = _step$fields.site) === null || _step$fields$site === void 0 ? void 0 : _step$fields$site.includes(process.env.NEXT_PUBLIC_SITE);
    }).forEach(function (step) {
      var _step$sys, _step$sys$contentType;
      var isService = (0, _utils.getProp)(step === null || step === void 0 ? void 0 : (_step$sys = step.sys) === null || _step$sys === void 0 ? void 0 : (_step$sys$contentType = _step$sys.contentType) === null || _step$sys$contentType === void 0 ? void 0 : _step$sys$contentType.sys, 'id') === 'service';
      steps.push(isService ? (0, _journeyService["default"])(step, section) : (0, _journeyStep["default"])(step, section));
    });
  });
  return _objectSpread(_objectSpread({}, (0, _journeyLite["default"])({
    sys: sys,
    fields: fields
  })), {}, {
    seo: (0, _utils.getProp)(fields, 'seo') ? (0, _seo["default"])({
      contentType: contentType,
      fields: fields
    }) : {},
    sections: sections,
    steps: steps,
    products: productLine ? (0, _orderJourneyProducts["default"])(productLine, extras) : [],
    conditionalCompletionPages: (0, _utils.getProp)(fields, 'conditionalCompletionPages') ? fields.conditionalCompletionPages.map(function (cd) {
      return (0, _conditionalDestination["default"])(cd);
    }) : null,
    kickouts: (0, _utils.getProp)(fields, 'kickouts') ? fields.kickouts.map(function (cd) {
      return (0, _conditionalDestination["default"])(cd);
    }) : null
  });
};
exports.createJourney = createJourney;
var journeyFactory = function journeyFactory(items) {
  return createJourney(items.shift());
};
var _default = journeyFactory;
exports["default"] = _default;